import React, { useState } from "react";
import AssignmentsTabs from "./display/AssignmentsTabs";
import AssignmentSearch from "./search/AssignmentSearch";
import { Box } from "@mui/joy";
import AssignmentHeader from "./display/AssignmentHeader";

const AssignmentsPage: React.FC = () => {
  const [isSearchMode, setIsSearchMode] = useState(false);

  const toggleMode = () => {
    setIsSearchMode(!isSearchMode);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: "hidden",
      }}
    >
      <AssignmentHeader isSearchMode={isSearchMode} onToggleMode={toggleMode} />
      <Box
        sx={{
          flex: "1 1 0",
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {isSearchMode ? <AssignmentSearch /> : <AssignmentsTabs />}
      </Box>
    </Box>
  );
};

export default AssignmentsPage;
